<template>
  <section id="videoPrincipal" class="py-5 position-relative bg-white">
    <div class="container">
      <div class="youtube-container">
        <iframe class="youtube-video " src="https://www.youtube.com/embed/9CmYK0u3kW0?si=ObK8_ERsvwxKD7uu?controls=0"  title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen  ></iframe>    
      </div>
    </div>
  </section>
</template>

<script>
  import { email } from "../../../utils/helpers"
  import { phone } from "../../../utils/helpers"

  export default {
    name: "VideoPrincipal",
    components: {},
    data() {
      return {
        email: email
      };
    },
    created() {},
    mesunted() {},
    methods: {
      enviarMensaje(Plan) {
        const phoneNumber = phone.number; // Reemplaza con el número de WhatsApp (sin signos ni espacios)
        const message = encodeURIComponent(`¡Hola! Me gustaría obtener más información sobre el plan ${Plan}.`); // Tu mensaje personalizado

        const url = `https://wa.me/${phoneNumber}?text=${message}`;
        window.open(url, "_blank");
      }
    }
  };
</script>

<style lang="scss" scoped>

    .youtube-container {
        width: 100%; /* O cualquier ancho que desees */
        height: 0;
        padding-bottom: 56.25%; /* Proporción de 16:9 (ancho/alto) */
        position: relative; /* Necesario para posicionamiento absoluto del iframe */
    }
    .youtube-video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

</style>
